import React, { useState } from "react";
import xlsx from "json-as-xlsx";
import { useDispatch } from "react-redux";
import {
  LeastsellingproductSlices,
  ListNotificationSlice,
  TopsellingproductSlices,
  TotalrevenueSlices,
  TotalSalesSlice,
  TotalusersSlices,
} from "../../redux/features/SalesAnalyticsSlice";

const SalesAnalytics = () => {

  const dispatch = useDispatch();

  const [prevkey, setKey] = useState("");

  let settings = {
    fileName: "MySpreadsheet", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    RTL: false, // Display the columns from right-to-left (the default value is false)
  };

  const handleDataSet=(iState)=>{
    
  const data = [
    {
      sheet: "Adults",
      columns: Object.keys(iState?.[0] || {})?.map((item) => ({
        label: item,
        value: item,
      })),
      content: iState,
    },
  ];
  xlsx(data, settings) // Will download the excel file

  }

  const handleDownload = (key) => {
    switch (key) {
      case "Total Revenue Report":
        dispatch(TotalrevenueSlices()).then(
          (res) =>{
            if(Array.isArray(res?.payload?.data) && key !== prevkey){
              handleDataSet(res?.payload?.data)
              setKey(key)
            } 
          }
        );
        break;

      case "Total Sales Report":
        dispatch(TotalSalesSlice()).then(
          (res) =>{
            if(Array.isArray(res?.payload?.data) && key !== prevkey){
              handleDataSet(res?.payload?.data)
              setKey(key)
            } 
          });
        break;

      case "Total Users Report":
        dispatch(TotalusersSlices()).then(
          (res) =>{
            if(Array.isArray(res?.payload?.data) && key !== prevkey){
              handleDataSet(res?.payload?.data)
              setKey(key)
            } 
          });
        break;

      case "Top Selling Products Report":
        dispatch(TopsellingproductSlices()).then(
          (res) =>{
            if(Array.isArray(res?.payload?.data) && key !== prevkey){
              handleDataSet(res?.payload?.data)
              setKey(key)
            } 
          });
        break;

      case "Least Sold Products Report":
        dispatch(LeastsellingproductSlices()).then(
          (res) =>{
            if(Array.isArray(res?.payload?.data) && key !== prevkey){
              handleDataSet(res?.payload?.data)
              setKey(key)
            } 
          });
        break;
    }
  };

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h2>Sales &amp; Analytics Reports</h2>
          </div>
          <div className="TableList">
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Reports</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Total Revenue Report</td>
                  <td>
                    <figure>
                      <img
                        onClick={() => handleDownload("Total Revenue Report")}
                        src={require("../../assets/images/download.png")}
                        alt=""
                      />
                    </figure>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Total Sales Report</td>
                  <td>
                    <figure>
                      <img
                        onClick={() => handleDownload("Total Sales Report")}
                        src={require("../../assets/images/download.png")}
                        alt=""
                      />
                    </figure>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Total Users Report</td>
                  <td>
                    <figure>
                      <img
                        onClick={() => handleDownload("Total Users Report")}
                        src={require("../../assets/images/download.png")}
                        alt=""
                      />
                    </figure>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Top Selling Products Report</td>
                  <td>
                    <figure>
                      <img
                        onClick={() =>
                          handleDownload("Top Selling Products Report")
                        }
                        src={require("../../assets/images/download.png")}
                        alt=""
                      />
                    </figure>
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Least Sold Products Report</td>
                  <td>
                    <figure>
                      <img
                        onClick={() =>
                          handleDownload("Least Sold Products Report")
                        }
                        src={require("../../assets/images/download.png")}
                        alt=""
                      />
                    </figure>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesAnalytics;
